import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fetchPartsLocationsDashboard} from '../actions/actions';
import {useNavigate} from 'react-router-dom';
import {fetchFileAsObjectUrl} from '../../common/util/file';
import Loader from '../../common/components/loader';


const PartsLocationDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.partsLocationDashboard?.loading);
  const data = useSelector((state) => state.partsLocationDashboard?.url);
  const [chartUrl, setChartUrl] = useState(null); // blob: del HTML del gráfico, ya descargado con el token
  const [chartError, setChartError] = useState(null);
  const [downloading, setDownloading] = useState(false); // bajando el HTML ya generado

  useEffect(() => {
    dispatch(fetchPartsLocationsDashboard());
  }, [dispatch]);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    if (data && !data.startsWith('http')) {
      navigate(data); // Redirige a una ruta interna
    } else if (data) {
      // /api/files exige token: no se puede abrir la URL directamente (navegación sin cabecera → 401) ni con
      // window.open tras la espera de generación (el navegador lo bloquea como ventana emergente). Se descarga
      // el HTML con el token y se muestra aquí mismo.
      setChartError(null);
      setDownloading(true);
      fetchFileAsObjectUrl(data)
        .then((url) => {
          if (cancelled) {
            URL.revokeObjectURL(url);
            return;
          }
          objectUrl = url;
          setChartUrl(url);
        })
        .catch((error) => {
          if (!cancelled) {
            setChartError(`No se pudo cargar el gráfico (${error.message})`);
          }
        })
        .finally(() => {
          if (!cancelled) {
            setDownloading(false);
          }
        });
    }
    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [data, navigate]);

  const openInNewTab = () => {
    if (chartUrl) {
      window.open(chartUrl, '_blank'); // el blob ya está descargado: se abre en el clic y el navegador no lo bloquea
    }
  };

  return (
    <div>
      <h2>Dashboard de Ubicación de Partes</h2>
      <button
        style={{
          'padding': '6px 16px',
          'background': '#1976d2',
          'color': '#fff',
          'border': 'none',
          'borderRadius': 4,
          'fontWeight': 'bold',
          'cursor': 'pointer',
        }}
        onClick={() => dispatch(fetchPartsLocationsDashboard())}
        disabled={loading}
      >Recargar</button>
      {' '}
      <button
        style={{
          'padding': '6px 16px',
          'background': '#fff',
          'color': '#1976d2',
          'border': '1px solid #1976d2',
          'borderRadius': 4,
          'fontWeight': 'bold',
          'cursor': chartUrl && !loading && !downloading ? 'pointer' : 'default',
        }}
        onClick={openInNewTab}
        disabled={!chartUrl || loading || downloading}
      >Ver en otra pestaña</button>
      {loading && <p>Generando el gráfico, puede tardar unos segundos...</p>}
      {chartError && <p style={{'color': '#c00'}}>{chartError}</p>}
      <div style={{'position': 'relative', 'height': 'calc(100vh - 220px)', 'marginTop': 12}}>
        {(loading || downloading) && (
          <div style={{
            'position': 'absolute', 'inset': 0, 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center',
            'background': 'rgba(255, 255, 255, 0.8)', 'zIndex': 1,
          }}>
            <Loader />
          </div>
        )}
        {chartUrl && (
          <iframe
            title='Dashboard de Ubicación de Partes'
            src={chartUrl}
            style={{'width': '100%', 'height': '100%', 'border': '1px solid #ddd'}}
          />
        )}
      </div>
    </div>
  );
};

export default PartsLocationDashboard;
